import { Script } from "gatsby";
import React from "react";

type Props = {
  oneTrustId?: string | null;
};

export default function CookieConsentAsync({ oneTrustId }: Props) {
  if (!oneTrustId) return null;
  return (
    <>
      <Script
        type="text/javascript"
        charSet="UTF-8"
        data-domain-script={oneTrustId}
        data-document-language="true"
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
      />
    </>
  );
}
